import { useSelector } from 'react-redux';
import { RemoteRecord } from '@client/common/redux/RemoteRecord';
import { AppState } from '@client/common/redux/store';
import { selectUpdateItemReferenceBySku } from '@client/myAccount/wishlists/redux/wishlist/redux';
import { UpdateItemReference } from 'b2b-common/core/account/api/wishlists';

export const useWishlistUpdateItemReference = (sku: string): RemoteRecord<UpdateItemReference> => useSelector(
  (state: AppState) => selectUpdateItemReferenceBySku(state, sku),
);
